import {
  Dialog,
  DialogContent,
  Box,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
  Slide,
  DialogTitle,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import XIcon from '@mui/icons-material/X';
import {
  FacebookShareButton,
  FacebookIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  LineShareButton,
  LineIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  EmailShareButton,
  EmailIcon,
  ViberShareButton,
  ViberIcon,
} from 'react-share';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  url: string;
  emailSubject?: string;
}

const UpTransition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RightTransition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="right" ref={ref} {...props} />;
});

export function ShareModal({ open, onClose, url, emailSubject }: ShareModalProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const shareButtonStyle = {
    width: 32,
    height: 32,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth TransitionComponent={isMobile ? RightTransition : UpTransition}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1 }}>
        <Typography sx={{ fontSize: 14, ml: 1 }}>Share</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" alignItems="center" flexWrap="wrap" justifyContent="center" py={3} gap={2}>
          <FacebookShareButton url={url} style={shareButtonStyle}>
            <FacebookIcon size={32} round />
          </FacebookShareButton>
          <FacebookMessengerShareButton url={url} appId="2852141398421242" style={shareButtonStyle}>
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
          <LineShareButton url={url} style={shareButtonStyle}>
            <LineIcon size={32} round />
          </LineShareButton>
          <WhatsappShareButton url={url} style={shareButtonStyle}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
          <TwitterShareButton url={url} style={shareButtonStyle} aria-label="Share to X">
            <Box
              sx={{
                width: 32,
                height: 32,
                bgcolor: 'black',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <XIcon sx={{ color: '#fff', fontSize: 20 }} />
            </Box>
          </TwitterShareButton>
          <ViberShareButton url={url} style={shareButtonStyle}>
            <ViberIcon size={32} round />
          </ViberShareButton>
          <EmailShareButton url={url} subject={emailSubject} style={shareButtonStyle}>
            <EmailIcon size={32} round />
          </EmailShareButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
